import { safeStorage } from '../store';

const KEY = 'ampshift.sessionId';
let memo: string | undefined;

function uuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  // Fallback for very old browsers / non-secure contexts.
  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') crypto.getRandomValues(bytes);
  else for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** One session id per browser tab (sessionStorage), generated once; the API keys patient context on it. */
export function getSessionId(): string {
  if (memo) return memo;
  const storage = safeStorage('session');
  const existing = storage?.getItem(KEY);
  if (existing) {
    memo = existing;
    return existing;
  }
  const fresh = uuid();
  try {
    storage?.setItem(KEY, fresh);
  } catch {
    /* ignore */
  }
  memo = fresh;
  return fresh;
}

/** Rotates the session id (used on sign-out so a new login gets fresh patient context). */
export function resetSessionId(): void {
  memo = undefined;
  try {
    safeStorage('session')?.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
